<div class="rectangle text-center">
  <img class="combined-shape top" [src]="'assets/images/png/paycell-logo.png'" [srcset]="'assets/images/png/paycell-logo@2x.png 2x, assets/images/png/paycell-logo@3x.png 3x'" alt="logo">
</div>
<div class="container pl-0 content">
  <div class="row">
    <div class="col-md-3 d-flex back-div">
      <div *ngIf="returnButtonShow">
        <img class="left-arrow" [src]="'assets/images/back.png'" [srcset]="'assets/images/back@2x.png 2x, assets/images/back@3x.png 3x'" alt="logo">
      </div>
      <div class="back-label-div" *ngIf="returnButtonShow">
        <label class="back-label" (click)="onClick()">{{keyValueMapping('backButton', 'Geri Dön')}}</label>
      </div>
    </div>

    <div class="col-md-5">
      <div class="text-center timeout-label-div" *ngIf="deadline != null && countdownShow">
        <label class="timeout-label">{{keyValueMapping('timerText', 'Kalan Süre')}}</label>
        <nz-countdown [nzValue]="deadline" [nzFormat]="'mm:ss'"
                      [nzValueStyle]="{'font-weight': 'bold', 'margin-bottom': '20px', 'color': 'black'}"
                      (nzCountdownFinish)="stop()"></nz-countdown>
      </div>
    </div>
    <div class="col-md-4 d-flex back-div justify-content-end" *ngIf="brandIcon">
      <div>
        <img class="bitmap" [src]="brandIcon" alt="logo">
      </div>
      <div>
        <img class="groceries" [src]="'assets/images/groceries.png'" [srcset]="'assets/images/groceries@2x.png 2x, assets/images/groceries@3x.png 3x'" alt="logo">
      </div>
      <div>
        <label class="price">{{'₺' + amount}}</label>
      </div>
    </div>
  </div>
</div>
